import loadable from '@loadable/component'

export default [
  {
    path: '/SVIPUpdate/BackModal',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-SVIPUpdate-pages-BackModal" */ '~/pages/SVIPUpdate/BackModal')
    ),
  },
  {
    path: '/SVIPUpdate/ExperModal',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-SVIPUpdate-pages-BackModal" */ '~/pages/SVIPUpdate/ExperModal')
    ),
  },
  {
    path: '/SVIPUpdate',
    exact: true,
    component: loadable(() => import(/* webpackChunkName: "page-SVIPUpdate-pages-SVIPUpdate" */ '~/pages/SVIPUpdate')),
  },
  {
    path: '/SVIPUpdate/detail',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-SVIPUpdate-pages-SVIPUpdatedetail" */ '~/pages/SVIPUpdate/Quanyi')
    ),
  },
]
